import { httpRequest } from "../../http";
import { Engagement } from "@models/engagement.model.ts";
import { EngagementSerializer } from "@models/serializers/engagementSerializer.ts";

/** One GuidePost's customization requests (MPN-1622). All optional. */
export interface AdCustomization {
    preferredNaming?: string;
    preferredCta?: string;
    messagingNotes?: string;
    imageVideoNotes?: string;
}

export interface RequestContentOpts {
    adIds?: number[];
    additionalNotes?: string;
    /** Keyed by ad id. A GuidePost with nothing filled in simply has no entry. */
    customizations?: Record<number, AdCustomization>;
}

export class CommandRequestContent {
    async run(provider_id: number, client_id: number, opts: RequestContentOpts = {}) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/request-content/`;
        const body: Record<string, unknown> = {
            service_provider: { id: provider_id },
            client: { id: client_id },
        };
        if (opts.adIds && opts.adIds.length > 0) {
            // Instructions ride beside each id rather than in one shared note, so the
            // server can file them against that GuidePost's own copy (MPN-1622). Blank
            // fields are omitted: an empty string would overwrite nothing with nothing
            // and makes the payload harder to read in a log.
            body.ads = opts.adIds.map((id) => {
                const c = opts.customizations?.[id] ?? {};
                const entry: Record<string, unknown> = { id };
                if (c.preferredNaming?.trim()) entry.preferred_naming = c.preferredNaming.trim();
                if (c.preferredCta?.trim()) entry.preferred_cta = c.preferredCta.trim();
                if (c.messagingNotes?.trim()) entry.messaging_notes = c.messagingNotes.trim();
                if (c.imageVideoNotes?.trim()) entry.image_video_notes = c.imageVideoNotes.trim();
                return entry;
            });
        }
        if (opts.additionalNotes) {
            body.additional_notes = opts.additionalNotes;
        }

        const response = await httpRequest<any>(url, { method: "POST", body });
        return new EngagementSerializer().deserialize(response) as Engagement;
    }
}
